<div class="schedule-table-part">
	<table cellspacing="0" class="white-box mt-3 w-100">
		<thead>
			<tr>
				<td></td> <!-- Empty top-left cell -->
				@for(day of dayIndices; track day;){
				<td class="py-2 px-0" role="button" >{{ commonLabels.DayNamesMap.long[day]()}}
				</td>
				}
			</tr>
		</thead>
		<tbody>
			@for(hour of hourNames(); track hour; let hour_idx= $index){
			<tr>
				<td class="px-1" role="button">{{ hour }}</td>

				@for(day_idx of dayIndices; track day_idx;) {
				<td class="p-0" role="button" [class.disabled]="disabledArr[day_idx]?.[hour_idx]">
					@if(selectedSlotsArr[day_idx]?.[hour_idx]){
						<i class="fa-regular fa-check fs-4"></i>
					} 
				</td>
				}
			</tr>
			}
		</tbody>
	</table>
</div>